<div class="flex h-full">
  <!-- Main Content Area -->
  <div class="flex flex-1 flex-col gap-4 overflow-y-auto p-4">
    <pr-dismissible-info-box
      theme="info"
      [dismissKey]="DismissibleInfoBoxKey.ReferralPatientLetterInfo"
    >
      This letter is for sending the referral to the patient only. It will not
      be sent to the email recipient. Use the Messages tab to communicate with
      the referral recipient.
    </pr-dismissible-info-box>
    <!-- Letter Editor (PDF Content) -->
    <pr-content-editor
      placeholder="Write your patient letter here..."
      class="max-h-[50vh] min-h-[300px] !flex-none overflow-y-auto"
      [menuItems]="menuItems()"
      [formControl]="form.controls.content"
      [defaultFont]="(documentSettings$ | async)?.fontFamily"
      [defaultLineHeight]="(documentSettings$ | async)?.lineHeight"
      [defaultParagraphSpacing]="(documentSettings$ | async)?.paragraphSpacing"
    />

    <mat-divider />

    <!-- Attachments & Clinical Notes Tabs -->
    <mat-tab-group
      mat-align-tabs="start"
      mat-stretch-tabs="false"
      fitInkBarToContent
      (selectedTabChange)="onTabChange($event)"
    >
      <mat-tab>
        <ng-template mat-tab-label>
          <span class="flex items-center gap-2 text-sm text-black">
            <mat-icon class="icon-sm">attach_file</mat-icon> Attachments
          </span>
        </ng-template>
        <div class="pt-4">
          <pr-referral-media-selection
            [media]="media()"
            [selectedRefs]="selectedAttachmentRefs()"
            (selectionChange)="onAttachmentsChange($event)"
          />
        </div>
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          <span class="flex items-center gap-2 text-sm text-black">
            <mat-icon class="icon-sm">description</mat-icon> Clinical Notes
          </span>
        </ng-template>
        <div class="pt-4">
          <pr-referral-clinical-note-selection
            [clinicalNotes]="patientClinicalNotes()"
            [referralClinicalNotes]="clinicalNotes()"
            [selectedRefs]="selectedClinicalNoteRefs()"
            [toggleEnabled]="includeClinicalNotesToggle()"
            (selectionChange)="onClinicalNoteSelectionChange($event)"
            (toggleChange)="onClinicalNotesToggleChange($event)"
          />
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>

  <!-- Sidebar -->
  <div class="w-80 shrink-0">
    <pr-referral-patient-letter-sidebar
      [patient]="patient()"
      [templates]="(printTemplates$ | async) ?? []"
      [isSending]="letterService.isSending()"
      [isGenerating]="letterService.isGeneratingPdf()"
      (headerTemplateChange)="onHeaderTemplateChange($event)"
      (footerTemplateChange)="onFooterTemplateChange($event)"
      (preview)="onPreview()"
      (download)="onDownload()"
      (send)="onSend()"
    />
  </div>
</div>
